import { JsonPipe } from '@angular/common';
import { Component, effect, OnDestroy, OnInit, Pipe, PipeTransform, signal } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { FormsModule } from '@angular/forms';

@Pipe({
    name: 'highlighter',
})
class HighlighterPipe implements PipeTransform {
    transform(value: any, args: any) {
        if (!args) {
            return value;
        }
        const re = new RegExp(args, 'gi'); //'gi' for case insensitive and can use 'g' if you want the search to be case sensitive.
        return value.replace(re, '<mark class="result">$&</mark>');
    }
}

@Component({
    selector: 'r1-compass-app-interceptor-data',
    imports: [JsonPipe, ClipboardModule, FormsModule, HighlighterPipe],
    template: `
        <div style="display: flex; flex-direction: column; margin: 1rem; gap: 1rem;">
            <section id="about">
                <h1>Interceptor Debug</h1>
                <p>
                    Note: local storage interceptor wipes it out after 10 minutes. And this may be outdated if a new
                    value wasn't set or removed.
                </p>
                <pre>{{ data.reqUrlWithParams | json }}</pre>
            </section>
            <section id="forms">
                <label for="url">URL to intercept</label>
                <input [(ngModel)]="url" style="width: 100%;" id="url" />
                <label for="keyTerm">Search term to highlight</label>
                <input [(ngModel)]="keyTerm" style="width: 100%;" id="keyTerm" />
            </section>
            <section id="buttons">
                <button type="button" (click)="copyData()">copy</button>
                <button type="button" (click)="scrollTo('result')">scroll</button>
            </section>
            <section id="content">
                <pre [innerHtml]="data.body | json | highlighter: keyTerm()"></pre>
            </section>
        </div>
    `,
})
export class InterceptorDataComponent implements OnDestroy, OnInit {
    keys = {
        keyTerm: 'interceptorSearchTerm',
        data: 'interceptor',
        url: 'interceptorUrl',
    } as const;

    data = JSON.parse(localStorage.getItem(this.keys.data) ?? '{}');

    keyTerm = signal(localStorage.getItem(this.keys.keyTerm) ?? '');
    url = signal(localStorage.getItem(this.keys.url) ?? '');

    constructor() {
        setInterval(() => {
            this.data = JSON.parse(localStorage.getItem('interceptor') ?? '{}');
        }, 1000);

        effect(() => {
            localStorage.setItem(this.keys.keyTerm, this.keyTerm());
        });
        effect(() => {
            localStorage.setItem(this.keys.url, this.url());
        });
    }

    ngOnInit() {
        setTimeout(() => {
            this.scrollTo('result');
        }, 100);
    }

    copyData() {
        navigator.clipboard.writeText(JSON.stringify(this.data.body, undefined, 2));
    }

    ngOnDestroy() {
        localStorage.removeItem(this.keys.keyTerm);
    }

    scrollTo(className: string): void {
        const elementList = document.querySelectorAll('.' + className);
        const element = elementList[0] as HTMLElement;
        element.scrollIntoView({ block: 'center' });
    }
}
